module.exports = __webpack_public_path__ + "img/Emissao_por_video.9d01fe6.svg";